import { Component, OnInit, ElementRef, forwardRef, ViewEncapsulation, Renderer, Injector } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, NG_VALUE_ACCESSOR, NG_VALIDATORS, ValidatorFn, AbstractControl, Validators } from '@angular/forms';
import { BaseAbstractControl, BaseFormControl, mohValidators, MohValidationErrors, FormSubmitService } from 'moh-package';
import { UtilitiesService } from '../../../services/general/utilities.service';

@Component({
  selector: 'moh-worsening-claimer',
  templateUrl: './worsening-claimer.component.html',
  styleUrls: ['./worsening-claimer.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [
    { provide: NG_VALUE_ACCESSOR, multi: true, useExisting: forwardRef(() => WorseningClaimerComponent) },
    { provide: NG_VALIDATORS, multi: true, useExisting: forwardRef(() => WorseningClaimerComponent) }]
})
export class WorseningClaimerComponent extends BaseAbstractControl implements OnInit, Validators {

  cityValidators: ValidatorFn[] = [];
  streetValidators: ValidatorFn[] = [];
  houseNumberValidators: ValidatorFn[] = [];
  entranceValidators: ValidatorFn[] = [];
  appartmentValidators: ValidatorFn[] = [];
  zipCodeValidators: ValidatorFn[] = [];
  postboxValidators: ValidatorFn[] = [];

  constructor(injector: Injector, private fb: FormBuilder, formSubmitService: FormSubmitService, private utilitiesService: UtilitiesService) {
    super(injector);
  }

  ngOnInit() {

    this.baseAbstractControl = new FormGroup({
      LastName: new FormControl('', [mohValidators.required(), mohValidators.minLength(2, "הערך בשדה שם משפחה קצר מידי יש להזין לפחות 2 תווים"), mohValidators.maxLength(25, "הערך בשדה שם משפחה ארוך מידי ניתן להזין עד 25 תווים"), mohValidators.pattern(new RegExp("^[{א-ת} \"']*$"), "יש להזין אותיות בעברית בלבד")]),
      FirstName: new FormControl('', [mohValidators.required(), mohValidators.minLength(2, "הערך בשדה שם פרטי קצר מידי יש להזין לפחות 2 תווים"), mohValidators.maxLength(25, "הערך בשדה שם פרטי ארוך מידי ניתן להזין עד 25 תווים"), mohValidators.pattern(new RegExp("^[{א-ת} \"']*$"), "יש להזין אותיות בעברית בלבד")]),
      IDNumber: new FormControl('', [mohValidators.required(), mohValidators.minLength(9, "נדרש להזין 9 ספרות"), mohValidators.maxLength(9, "נדרש להקליד 9 ספרות בלבד"), mohValidators.idNumber("המספר שהוקלד אינו תקין, אנא בדוק שנית וודא את ספרת הביקורת")]),
      PhoneNumber: new FormControl('', []),
      MobileNumber: new FormControl('', []),
      FaxNumber: new FormControl('', []),
      Email: new FormControl('', [mohValidators.required(), mohValidators.maxLength(50), mohValidators.email('יש להזין כתובת תקנית באותיות לועזיות וללא רווחים')]),
      PostAddress: new FormControl('', [])
    });

    this.cityValidators = [mohValidators.required()];
    this.streetValidators = [mohValidators.required(), this.utilitiesService.streetPattern(new RegExp("^[{א-ת} 0-9\"']*$"), "יש להזין ספרות ואותיות עבריות בלבד")];
    this.houseNumberValidators = [mohValidators.required(), mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מספר בית יש להזין ערך מספרי שלם בלבד")];
    this.appartmentValidators = [mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מספר דירה יש להזין ערך מספרי שלם בלבד")];
    this.zipCodeValidators = [mohValidators.required(), mohValidators.minLength(5), mohValidators.maxLength(7), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה מיקוד יש להזין ערך מספרי שלם בלבד")];
    this.postboxValidators = [mohValidators.maxLength(5), mohValidators.pattern(new RegExp("^[0-9]+$"), "בשדה ת.ד. יש להזין ערך מספרי שלם בלבד")]

    super.ngOnInit();
  }
}





// WEBPACK FOOTER //
// E:/Develop/MOH.Gazezet/Dev/MOH.Gazzezet/MOH.Gazzezet/src/app/components/worsening/worsening-claimer/worsening-claimer.component.ts